import { baseClient } from '@/core/infrastructure/api/apiClient';
import { translate } from '@/core/utils/translate';
import { LiveFeaturesResponse } from './type';

export const featuresAndInnovationsQueries = {
  keys: {
    all: ['featuresAndInnovations'] as const,
    liveFeatures: () => [...featuresAndInnovationsQueries.keys.all, 'liveFeatures'] as const,
  },

  fn: {
    fetchLiveFeatures: async (): Promise<LiveFeaturesResponse> => {
      try {
        const response = await baseClient.get<LiveFeaturesResponse>('live_features');
        return response.data;
      } catch (error: any) {
        throw new Error(
          translate('errors/api:live_features_fetch_failed', {
            error: error.response?.data?.message || error.message,
          })
        );
      }
    },
  },
};
